/*
 * General JS and AJAX routines for controlling the AppState and Server Page Requests.........
 */

import { setOnCall } from '../redux/otuVision/actions';
import { getStore } from '../redux/store' 


var buildVersionInfo=require('../../buildVersionInfo.json');
var _headers = {};
var lastUploadAjaxCall = null;
var licenseExpiryTimer=null;

global.otuApp= {
		appState:{
				hideTemplatePositions:null,
				mapZIndex:null,
				lastQuery:'',
				rootUrl:''
		},
		appUser:{
			json:{}
		},
		menuBarInitialized:false,
		preloadSplash:false,
		buildVersionInfo,
		windowHistoryLength:0

}


otuApp.isCordovaApp= function () {
	if (typeof frameWork!== 'undefined') {
		return frameWork.isCordova;
	}
	return false;
}

otuApp.addHeaders = function (options = { headers :{}}) {
	_headers = Object.assign({},_headers,options.headers);
}

otuApp.getHeaders = function() {

	console.log('adding-headers');
	var headers = Object.assign({},_headers);

	if (otuApp.isCordovaApp()) {
		headers['X-OTU-APP-TOKEN']=myApp.getToken();
	}

	// Add the timezone headers
	var d = new Date()
	var n = d.getTimezoneOffset();
	headers['timezoneOffset']=n;
	var t = Intl.DateTimeFormat().resolvedOptions().timeZone;
	headers['timezone']=t;

	//console.log('headers',headers);
	return headers;
}

if (otuApp.isCordovaApp()) {
	console.log('Cordova detected');
}


// local vars
var historyQ=$({});
var previousHistoryState={id:0};

// some general settings
//set ajaxtimeout to 3 minutes
const ajaxSetupOptions = {
		xhrFields: {
			withCredentials: true
	},
	beforeSend: function(xhr, settings) {		

			if ( otuApp.isCordovaApp() ) {

				settings.url = otuApp.pageNavigation.route( settings )
				
			}

			return true;
			
		},
	timeout: 180000
}
	
$.ajaxSetup(ajaxSetupOptions);

$.fn.hasAttr = function(name) {  
   return this.attr(name) !== undefined;
};


function addParameterToURL(url,param,value){

    var _url = url
    _url += (_url.split('?')[1] ? '&':'?') + param + '=' + value;
    return _url;
}

function removeParameterUrl(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts= url.split('?');   
    if (urlparts.length>=2) {

        var prefix= encodeURIComponent(parameter)+'=';
        var pars= urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i= pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}


// hides a template position by adding it to its own animation queue
function hideTemplatePosition(templatePosition, effectOut) {
	console.log('Templates - Hide Template');

	var that = $('[data-template-position="' + templatePosition + '"]');

	var onBeforeHideEvents = $(that).data('onTemplateBeforeHide');
	if (Array.isArray(onBeforeHideEvents))
	onBeforeHideEvents.forEach(element => {
		if (typeof element === 'function') {
		 console.log('Templates - onBeforeHideEvents Event');
			element({templatePosition:that});
		} else {
			throw 'Templates - onBeforeHideEvents element not a function.'
		}
	});

	if (!effectOut) effectOut=that.hasAttr('data-effect-out')? that.attr('data-effect-out'):'fadeOut';
	
	if (!$(that).length) {
		console.log('Templates - Template Position does not exist, cannot hide ' + templatePosition);
		return true;
	}
	
	if (that.css('visibility')=='hidden' || effectOut=='ignore' || !$(that).children().length ) {
		console.log ('Template Position is already hidden, empty or ignored ' +  templatePosition + ' (' + effectOut + ')');
		return;
	}
	// force hide iframes, the do not always want to hide well
	console.log('Tempaltes - Force hide IFrames');
	$( that ).find('iframe').fadeOut();
	
	console.log('hiding - template position ' +  templatePosition + ' ' + effectOut);

	if (effectOut=='none' || otuApp.isCordovaApp()) {
		$( that ).css({"visibility":"hidden"});
		console.log('Templates - Template Hidden ' + templatePosition + ' (' + effectOut + ')');
		return true;
	} else {
		// now we need to queue this on that and then it should work
		otuApp.fxQ.queue( function(next) {
				$( that ).animateCSS(effectOut, {
						duration:otuApp.fxOptions.stepChangeDuration, 
						callback:function() {
							$( that ).css({"visibility":"hidden"});
							console.log('Templates - Template Hidden ' + templatePosition + ' (' + effectOut + ')');
							next(); // = .dequeue
						}
				});				
		});
	}
}

function showTemplatePosition(templatePosition, effectIn) {
	var that = $('[data-template-position="' + templatePosition + '"]')
	if (!effectIn) effectIn=that.hasAttr('data-effect-in')? that.attr('data-effect-in'):'fadeIn';
	//console.log('showing-template position ' +  templatePosition + ' ' + effectIn);
	if (!$(that).length) {
		console.log('Templates - Template position does not exist, cannot show ' + templatePosition);
		return true;
	}
	
	if (!(typeof otuApp.appState.hiddenTemplatePositions=='undefined' || otuApp.appState.hiddenTemplatePositions==null)) {
		var index = otuApp.appState.hiddenTemplatePositions.indexOf(templatePosition);
		if (index > -1) {
			//console.log('clearing hiddenTemplatePosition',templatePosition);
			otuApp.appState.hiddenTemplatePositions.splice(index, 1);
		}	
	}

	// make sure video iframe are visible
	$( that ).find('iframe').fadeIn();

	if (effectIn=='none') { 
		$( that ).css({"visibility":"visible"});
		$(window).trigger('resize'); // force a redraw of the window, seems to solve a screen scoll lock on chrome

	} else {
		// now we need to queue this on that and then it should work
		otuApp.fxQ.queue( function(next) {
			$( that ).animateCSS(effectIn, {
				duration:otuApp.fxOptions.stepChangeDuration, 
				callback:function() {
					console.log('Templates - Template Shown ' + templatePosition + ' (' + effectIn + ')');
					$(window).trigger('resize'); // force a redraw of the window, seems to solve a screen scoll lock on chrome
					next(); // = .dequeue

				}	
			});
		});
	}	
}

otuApp.restoreHiddenTemplatePositions = function () {
	if (otuApp.appState.hiddenTemplatePositions!==null) {
		// at the moment we only restore the main template only.
		$.each(otuApp.appState.hiddenTemplatePositions,function(i,value){
			if (value=='columns-all') showTemplatePosition(value,'fadeIn');
			$('.background-map-wrapper').css('z-index',otuApp.appState.mapZIndex);

		});
		
	}

}

// Refreshes a client template after an AJAX request
function refreshTemplatePosition(data,f_options={}) {
	 var options = {hideTemplatePositions:[],hiddenTemplatePositions:[]};
	 $.extend(options,f_options );
	 // Wrap up the data, so we can access the Parent node too we we parse this as HTML with $(data)
	 data = '<div>' + data +  '</div>';		
	 
	 // Refresh the template positions HTML with the result, lets asume they are available 
	 $(data).find('[data-ajax-action="refresh"]').each(function (i,ele) {
		 // Identify the template
		 var templatePosition=$(this).attr('data-template-position');
		 console.log('Templates - Refreshing ' + templatePosition);
		 var that = $('[data-template-position="' + templatePosition + '"]');
		 var node=this;
		 var doAppStateRefresh=true;
		 
		 
		 // we need to read the effect out from the current slide and the effect in from the new slide
		 var effectOut=($(that).hasAttr('data-effect-out')? $(that).attr('data-effect-out'):'fadeOut');
		 var nextEffectOut=($(this).hasAttr('data-effect-out')? $(this).attr('data-effect-out'):'fadeOut');
		 var effectIn=($(this).hasAttr('data-effect-in')? $(this).attr('data-effect-in'):'fadeIn');
		 


		 if ($.inArray(templatePosition,options.hiddenTemplatePositions)==-1) {
			 // hide the tempate position first if its not hidden
			 hideTemplatePosition(templatePosition,effectOut);
		 }

		 console.log('Templates - Preparing new');

		 // Set the fadeOut effect for when hiding next time, only if we not ignore it
		 $(that).attr("data-effect-out",nextEffectOut);

		 // clear the template position
		 otuApp.fxQ.queue(function(next){
			 // if we have react components to unmount we unmount them now
			 var reactNodes = $(that).data('reactNodes');
			 if (Array.isArray(reactNodes)) {
				 reactNodes.forEach((reactNode) =>{
					 OTUReact.unmountContainer(reactNode);
				 })
			 }
			 $(that).data('reactNodes',[]);
			 //console.log('Templates - Cleared ' + templatePosition);
			 // if we have onDestroy events we execute them now
			 var onDestroyEvents = $(that).data('onTemplatePositionDestroy');
			 if (Array.isArray(onDestroyEvents))
			 onDestroyEvents.forEach(element => {
				 if (typeof element === 'function') {
					console.log('Templates - onTemplatePositionDestroy Event');
					 element({templatePosition:that});
				 } else {
					 throw 'Templates - onDestroy element not a function.'
				 }
			 });
			 $(that).data('onTemplatePositionDestroy',[]);
			 console.log('Templates - Emptying');
			 $(that).empty();
			 next();
		 })
		 
		 // TODO Appstate should only be added once per request 
		 // TODO add the appState first so its available to all scripts
         $(this).find('script[data-app-state="true"]').each(
        		 function(i,ele) {
							 console.log('Appstate - Injecting New State');
        			 // why does this work and should I not remove ELE i have no clue
        			 $(that).append(ele);  
        			 // now bind the new appState to the temlatePosition too so we do not loose it
        			 // TODO Use templateParams from templatePosition and not from legacy global appState
        			 otuApp.appState.templateParams.templatePosition=$(that).attr('data-template-position');
        			 $(that).data('templateParams',Object.assign({},otuApp.appState.templateParams));
							 doAppStateRefresh=true;
							 console.log('appState - New State Injected');
        		 }
         );
		 // Refresh the template-position with html


		 var html=$(this).html();


		 otuApp.fxQ.queue(function (next){
			 if (typeof otuApp.appState.templateParams !== 'undefined') {
				 // check if we need to refresh the background
				 if (typeof backgroundMap !== 'undefined' && typeof otuApp.appState.templateParams.backgroundMap !== 'undefined') {
					  otuApp.setBackgroundMapOverlay(backgroundMap,{url:otuApp.appState.rootUrl + otuApp.appState.templateParams.backgroundMap});	
			 }} 			 

			 console.log('Templates - Injecting new HTML');

			 $( that ).append(html);

			 console.log('Templates - HTML Injected');


			 $( that ).scrollTop(0);

			 // queue showing the template, (so we can add to the otuApp.fxQ)			 
			 if (effectIn!='force-hidden') showTemplatePosition(templatePosition,effectIn)
			 // if the template contains javascript it will be executed now.
			 // we can refresh the app state inmediately after we refreshed the html	
			 
			 if (doAppStateRefresh) {
				 //console.log('-----> refreshing appstate from ' + templatePosition);
				 otuApp.appStateRefresh() ;

				 if (f_options.jsonCallback) {
					 console.log('Ajax - jsonCallback found');
					 console.log(otuApp.appState.jsonCallbackResult);
					 if ( otuApp.appState.jsonCallbackResult ) {
						f_options.jsonCallback( otuApp.appState.jsonCallbackResult )
					 } else if ( f_options.jsonErrorCallback ) { 
							console.log('Ajax - JSON expected but template returned with no resultCallback data, callback ignored but error callback triggered');
							f_options.jsonErrorCallback();
					 }
					}
			 }

			 
			 next(); // =.dequeue 
		 })
		 		
		 
	
	 });

	return true;
}

// Binds the handlers for user actions
function bindHandlers() {
	// here we bind all the handlers, usually on document load or an AJAX refresh.
	//console.log('bindhandlers');
	otuApp.registerAjaxHandlers();
	
	// bind ToneUpTalkmenu Handlers
	$('.openToneUpTalkModal').off('click');
	$('.openToneUpTalkModal').click( function (e) {
		e.stopPropagation();
		var type=$(this).attr('data-modalType');
		messaging.openModal(type);
		}
	);

	// page Navigation Handlers
	$('.app-restore-task').off('click');
		$('.app-restore-task').click(function () {
			otuApp.pageNavigation.restoreTask();
	});

	$('.app-restore-task-toneUpTalk').off('click');
		$('.app-restore-task-toneUpTalk').click(function () {
			otuApp.pageNavigation.restoreTask({toneUpTalk:true});
	});
	
	// back button handlers
	$('.app-back-button').off('click');
	$('.app-back-button').click(function () {
		otuApp.jsBack();
	});
	
	// back button handlers no pop for inhistory = false
	$('.app-back-button-nopop').off('click');
	$('.app-back-button-nopop').click(function () {
		otuApp.jsBack({pop:false});
	});
	
	$('.app-back2island-button').off('click');
	$('.app-back2island-button').click(function () {
		var url=otuApp.appState.rootUrl + '?component=com_otu_op&task=goToStep&step=0;';
		otuApp.triggerAjaxGet(url);
	});

	// back button handlers
	$('.app-back-button-custom').off('click');
	$('.app-back-button-custom').click(function () {
		var url=$(this).attr('data-url');
		otuApp.triggerAjaxGet(url);
	});
	
	// specific for columns all
	$('[data-template-position="columns-all"]').off('click');
	var _params=otuApp.getTemplateParams();
	if (_params.backOnSideClick) {

		$('[data-template-position="columns-all"],.workoutGeneratorVideoBorderless').on('click',function(e){
			if (e.target === this) otuApp.pageNavigation.restoreTask();
		});
		/*
		$('[data-template-position="columns-all"]').one('click',function(e){
			var __params=otuApp.getTemplateParams();
			if (e.target === this) otuApp.jsBack({pop:(typeof __params.backPop==='undefined'?true:__params.backPop)});
		});
		*/
	} 
	
	// when we click an external link we stop the seasound
	$('a[target="_blank"]').click(function() {
		console.log('Animations - Stopping animations because we left on a new window link...');
		otuApp.stopSeaSounds();
		//otuApp.stopAnimations();
		// if the menu is open we close it...
		if (typeof appMenu!='undefined') appMenu.hide();
	})
	
	 setTimeout(otuApp.animateOnHover('h1','rubberBand'),1000);	


	
	return true;
}

otuApp.bindHandlers=bindHandlers;

otuApp.appStateRefresh = function () {
	console.log('Appstate - Refresh')
	//console.log(window.otuApp.appState.templateParams);
	//console.log('AppUser Refreshed')
	//console.log(window.appUser);
	
	// if we just logged in reconnect as user
	if ( socketIo.guest ? !otuApp.appUser.guest : otuApp.appUser.guest ) {
		if (socketIo.connected && socketIo.authenticated)	{
			console.log('SocketIo - Re-authenticate');
			socketIo.authenticate();
		}
	}

	// set a license expiry timer
	if (!otuApp.appUser.guest && otuApp.appUser.licenseExpiry) {
		let expiryDate = new Date(Date.parse(otuApp.appUser.licenseExpiry));
		let startDate = new Date();
		var seconds = (expiryDate - startDate) / 1000;
		if (seconds<7200 && seconds>0) {
			clearTimeout(licenseExpiryTimer);
			console.log('License - Setting expiry timeout to ' + seconds + ' seconds');
			licenseExpiryTimer = setTimeout(function () {
				console.log('License - Expiry triggered')
				let url=otuApp.appState.rootUrl  + 'index.php?component=com_otu_op&task=demo.endDemo';
				otuApp.triggerAjaxGet(url);
			},(seconds)*1000);
		}
	} else {
		clearTimeout(licenseExpiryTimer);
	}
	
	// always try to connect just in case we lost the connection
	if (!socketIo.connected && !socketIo.connecting) {
		console.log('SocketIo - Re-Connect');
		socketIo.connect();
	}
	
	// if we were playing the catchAWave game multiplayer make sure we give up..
	if (!catchAWave.isVisible() && catchAWave.connectIsGameOn()) {
		console.log('Catch A Wave - Left Catch A Wave Multi Player Game so given up')
		catchAWave.giveUp();
	}

	// if we were playing the catch a wave game single player and it is no longer visible make sure we end it
	if (!catchAWave.isVisible() && catchAWave.isSinglePlayerGameOn()) {
		console.log('Catch A Wave - Left Catch A Wave Single Player Game so given up')
		catchAWave.giveUp();
	}

	otuApp.updateProgressIndicator();
		

	// handle page Navigation
	if (typeof otuApp.appState.templateParams!='undefined') {
		if (typeof otuApp.appState.templateParams.pageNavigation!='undefined') {
			var pageNavigationOptions=otuApp.appState.templateParams.pageNavigation;

			lastQuery=otuApp.appState.lastQuery;
			lastQuery=lastQuery.replace('?tmpl=ajax', '');	
			lastQuery=lastQuery.replace('&tmpl=ajax', '');	
			lastQuery=lastQuery.replace('tmpl=ajax', '');
			if (lastQuery.indexOf('task=getPreviousStep') > -1 || lastQuery.indexOf('task=getNextStep') > -1) {
				lastQuery='task=goToStep&step=' + otuApp.appState.templateParams.id;
			}
			
			if (typeof pageNavigationOptions.url==='undefined') {
				pageNavigationOptions.url=removeParameterUrl(otuApp.appState.lastPath + (lastQuery?'?' + lastQuery:''),'currentStep');
			}
			otuApp.pageNavigation.add(pageNavigationOptions);
		
		}

		if (typeof otuApp.appState.templateParams.template !=='undefined') {
			$('#templateFileName').html('- ' + otuApp.appState.templateParams.template)
		}

		// check the head language tag
		if ( otuApp.appState.languageTag && ( !$('html').attr('xml:lang') || ( $('html').attr('xml:lang').toLowerCase()!==otuApp.appState.languageTag || $('html').attr('lang').toLowerCase()!==otuApp.appState.languageTag) ) ) {
			console.log('Language - Switching Language');
			$('html').attr('xml:lang',otuApp.appState.languageTag.toLowerCase());
			$('html').attr('lang',otuApp.appState.languageTag.toLowerCase());

		}
	}



	/*
	 * 
	 * Handle browser History in PushState
	 * 
	 */ 
	// TODO lastQuery may be reset by a new query by now.
	 //var lastQuery=otuApp.appState.lastQuery;
	 if (window.history.pushState) {
		 	var lastQuery='';
		 	var lastHistory=null;
		 	var previousHistory=null;
		 	if (typeof otuApp.appState.templateParams!='undefined') {
	 			var inHistory=true;
	 			if (typeof otuApp.appState.templateParams.inHistory!=='undefined') {
	 				inHistory=otuApp.appState.templateParams.inHistory; 
	 			}
	 			
	 				lastQuery=otuApp.appState.lastQuery;
	 				// if we are not inhistory or check if we don't come from a pop state event
		 			if ((lastQuery.indexOf('popHistory=1') === -1) &&  inHistory) {
		 				
		 				
			 			// we are storing a different query not from our component we preserve path and query sting and flag it
		 				previousHistoryState.id=-1;
		 				previousHistoryState.type=2;

		 				//lastQuery=otuApp.appState.lastQuery;
		 				lastQuery=lastQuery.replace('?tmpl=ajax', '');	
		 				lastQuery=lastQuery.replace('&tmpl=ajax', '');	
		 			 	lastQuery=lastQuery.replace('tmpl=ajax', '');
		 			 	
 						if (lastQuery.indexOf('task=getPreviousStep') > -1 || lastQuery.indexOf('task=getNextStep') > -1) {
 							lastQuery='task=goToStep&step=' + otuApp.appState.templateParams.id;
 						}
 						
 						lastHistory=removeParameterUrl(otuApp.appState.lastPath + '?' + lastQuery,'currentStep');
 						previousHistory=removeParameterUrl(previousHistoryState.lastPath + '?' + previousHistoryState.lastQuery,'currentStep');
 						//console.log(lastHistory);
 						//console.log(previousHistory);
 						
		 				if ( lastHistory!=
		 					previousHistory) {	 			 					
				 			previousHistoryState.lastQuery=lastQuery;
				 			previousHistoryState.lastPath=otuApp.appState.lastPath;
				 			if (((!isDebugUser()) || otuApp.isCordovaApp()) && !otuApp.appState.templateParams.pushQueryUrl && !license.isTranslator()) {
								if (!otuApp.isCordovaApp()) {
									window.history.pushState(previousHistoryState, 'Operation Tone-Up Online Program', otuApp.appState.lastPath);
									otuApp.windowHistoryLength++;
								} else {
									window.history.pushState(previousHistoryState, 'Operation Tone-Up Online Program', '');
									otuApp.windowHistoryLength++;

								}
				 			} else {
								 if (otuApp.appState.templateParams && otuApp.appState.templateParams.pushQueryUrl) {
									console.log('History - Push Query URL' +  otuApp.appState.lastPath + (lastQuery ?'?' + lastQuery:''));
								 }
								 window.history.pushState(previousHistoryState, 'Operation Tone-Up Online Program', otuApp.appState.lastPath + (lastQuery ?'?' + lastQuery:''));
								 otuApp.windowHistoryLength++;

				 			}
				 				
				 				console.log('History - Add '+ otuApp.appState.lastPath + '?' + lastQuery + '(' + previousHistoryState.type + ')');
		 				} else {
		 					console.log('History - URL not added, its the same.');
		 				}
		 			} else {
				 		 if (!inHistory) console.log('History - inHistory false');
				 		 if (lastQuery.indexOf('popHistory=1') !== -1) console.log('History - popHistory true');
		 			}		 			
		 			//}
		 	} else {
				 console.log('History - Template Params undefined');
		 	}
	 } else {
		 console.log('History - Not pushing state');
	 }
	
	// Rebind all handlers
	bindHandlers(); 
		

	// Load menubar if requested
	if ((typeof isPdf =='undefined') && (otuApp.appState.hasMenuBar===true && ($("#" + otuApp.appState.menuBarTemplate).length === 0)) && (!otuApp.menuBarInitialized)) {
		otuApp.menuBarInitialized=true;
		// We must load the menu
		console.log('Menubar - Loading Menubar');

		var href=otuApp.appState.rootUrl + '?component=com_otu_op&task=getMenu&layout=menubar&inHistory=0';
		var headers=otuApp.getHeaders();

		$.ajax( {
			url:href,
			headers: headers,
			success:function( resultData ) {
				refreshTemplatePosition(resultData);
				}
		});
		
	} else {
		console.log('Menubar - Leave as is')
	}
	
	if (otuApp.appState.hasMenuBar===false) {
		console.log('Menu Bar - Hide Requested otuApp.appState.hasMenubar=false');
		$('#menu-bar-wrapper').empty();
		otuApp.menuBarInitialized=false;

	}
	
	// refresh the score here
	if (!otuApp.appUser.guest) {
		if (typeof otuApp.appUser.points!=='undefined' && typeof otuApp.appUser.points!=='undefined') {	
			if ($('#score').html()!=otuApp.numberWithCommas(otuApp.appUser.points)) {
				$('#score').html(otuApp.numberWithCommas(otuApp.appUser.points));
				$('#score-counter-wrapper').animateCSS('flash');
			}
			var n = 0;
			for (var _ in otuApp.appUser.json.mission1.supplies) n++;
			if ($('#supplies').html()!=n) {
				$('#supplies').html(n);
				$('#supplies-counter-wrapper').animateCSS('flash');
			}			
		}
	}
	
	// refresh unread messages if forced
	
	if (otuApp.appState.messagesUpdateUnread===true) {
		console.log('Messages - Update Unread (' + otuApp.appState.messagesUnread + ')');
		var count=parseInt($.trim($('#newMessageCounter').text()),10);	
		messaging.setMessageCounters(otuApp.appState.messagesUnread, otuApp.appState.messagesUnreadByType);		
		if (count<otuApp.appState.messagesUnread) {
			otuApp.preload({sounds:['new-message']}, function() {
				$('#newMessageCounter').animateCSS('flash');
				if (!messaging.modalOpen) {
					console.log('Messages - Play New Message Sound');
					createjs.Sound.play('new-message',{volume:otuApp.fxOptions.newMessageVolume});
				}

			});			
		}
	}
	
	// enable/disable the NSGG

	if (!otuApp.appUser.guest && (typeof otuApp.appUser.guest!=='undefined')) {
		if (otuApp.appUser.json.mission1.catchNsggEnabled && otuApp.catchNsggDisabled!==true) {
			if (!otuApp.appState.catchNsggTimerRunning){
				otuApp.appState.catchNsggTimerRunning=true;
				console.log('Nsgg - Timer Started');
				otuApp.appState.catchNsggTimerId=setTimeout(function(){

					const reduxState = getStore().getState();

					if (typeof otuApp.appState.templateParams.video!=='undefined' 
							||
							otuApp.appState.templateParams.NSGGDisabled===true 
								|| 
								otuApp.getTemplateParams().NSGGDisabled===true 
									|| reduxState.otuVision.onCall ) {
						console.log('Nsgg - Skipped because it is disabled for this page.');
					} else {
						var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=goToStep&step=291';
						otuApp.triggerAjaxGet(url, {attr:{"data-keep-animation":"true"}});
						console.log('Nsgg - Triggered');
						otuApp.appState.catchNsggTimerRunning=false;
					}
				},300000);				
			}
		} else {
			// make sure that if the timer is running we clear it
			clearTimeout(otuApp.appState.catchNsggTimerId);
			otuApp.appState.catchNsggTimerRunning=false;			
		}
		
	}	
	
	// load and show the popups
	
	if (typeof otuApp.appState.messagesWaitingPopups != 'undefined') {
		messaging.showPopups(otuApp.appState.messagesWaitingPopups);
	}
	
	// cordova specific
	if (otuApp.isCordovaApp()) {
		myApp.appStateRefresh();
	}

	// fade in images when they are loaded if the are declared with data-src
	[].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
		img.setAttribute('src', img.getAttribute('data-src'));
		img.onload = function() {
			img.removeAttribute('data-src');
		};
	});
	
	if (otuApp.appUser.guest) {
		// make sure the modal messagewindow is not loaded
		messaging.modalLoaded=false;		
		
	}
	if (license.isTranslator()) {
		const state = getStore().getState();
		if ( otuApp.appState.useTranslateUI ) {

			if (!state.translate.widgetVisible) {
				otuApp.translate.showWidget();
			} 

			otuApp.translate.update();

		} else {
			if (state.translate.widgetVisible) {
				otuApp.translate.hideWidget();
			} 
		}

	}

			const state = getStore().getState();



	
}

otuApp.stopAnimations = function() {
	// Templates as a rules always start fresh
	console.log('Animations - Stop Animations');
	// we stop the sea sound if it is playing
	
	otuApp.stopSeaSounds();
	
	// kill any running gsap Timelines
	for (let i = 0; i < otuApp.gsapTLs.length; i++) { 
		otuApp.gsapTLs[i].kill();
		otuApp.gsapTLs.splice(i, 1);
	}
	
	
	// stop the radio if it is playing
	if (otuApp.radioState.playing) otuApp.stopRadio();

	
	// if sounds are playing
	var tmpFxSounds=otuApp.fxSounds.slice();
	otuApp.fxSounds=[];
	for (let i=0;i<tmpFxSounds.length;i++) {
		if (tmpFxSounds[i].playState!==createjs.Sound.PLAY_FINISHED) {
 			TweenLite.to(tmpFxSounds[i],1,
 				{
 					volume:0,
 					onComplete: function(){
 						tmpFxSounds[i].stop();	
 					}
 				}
 			);
		}		
	};
	
	
	
	if (otuApp.endingSong!==null) {
		if (otuApp.endingSong.playState!==createjs.Sound.PLAY_FINISHED) {
 			TweenLite.to(otuApp.endingSong,5,{volume:0,onComplete: function(){
 				otuApp.endingSong.stop();
 			}});

		}
	}
	
	/*
	
	$('#audio-library #sea-sound').animate({volume:0},200, function() {
		$('#audio-library #sea-sound').get(0).pause();
		console.log('stopping sea sound');
	});
	*/
	
	/*
	if ($( "#audio" ).length) {
		otuApp.fxQ.queue(function(next) {
			$('#audio').animate({volume:0},200, function() {
				$('#audio').get(0).pause();
			});
			console.log('stop audio');
			next();
		});
	
	}
	*/
	// we always send to background map to the back
	$('.background-map-wrapper').css('z-index',-20);
		
	// we unbind any scroll events
		$('.column-wrapper').unbind('scroll');

		$(window).unbind('scroll');
		$(window).unbind("resize.wowbook");
}



// Registers the AJAX handlers for comm to the server 
otuApp.registerAjaxHandlers = function () {
	console.log('Ajax Handler - Registering ajax handlers');
	// Register the link GETS
	$('a[data-ajax="true"],div[data-ajax="true"]').off('click');
	$('a[data-ajax="true"],div[data-ajax="true"]').click(function (e) {
		var href=this.getAttribute('href');	

		console.log('Ajax Handler - User Follow Link');
		
		// Hide the ajax error, if it is visible
		if (otuApp.isCordovaApp() && $('.cordova-app-messages').is(':visible')) {
			$('.cordova-app-messages').hide()
		} 

		if ( otuApp.appState.fundraiserDomain && (href.startsWith('http') && !href.startsWith(otuApp.appState.rootUrl))) {
			// have an external link 
			console.log('Ajax Handler - Fundraiser reverse link', href,otuApp.appState.rootUrl);
			window.location.assign(href);
			return true;
		}
	

		if (!$(this).hasClass('withPropagation')) {
			e.stopPropagation();	
			e.preventDefault();
		} 
		
		var templateOptions={};
		
		// the AJAX call
		
		// a hack to stop the NSGG from running multiple times
		if (otuApp.appState.catchNsggRunning===true && href.indexOf('step=291')>0) {
			console.log('Nsgg - Already running not triggering a new one');
			return false;
		}	
		// if disabled do nothing
		if ($(this).attr('data-link-disabled')=="true") {
				return false;
		}
		// we came from the menu so we add it to history
		if (typeof appMenu!=='undefined') {
			if (!appMenu.hidden) {
				 // push it into the window.history state
				 //console.log('History - Pushing app menu into history');
	 			//	var previousHistoryState = {};
	 			//	previousHistoryState.type=3;	
	 			//	window.history.pushState(previousHistoryState, 'Operation Tone-Up Online Program', '');				
				appMenu.hide();
			}
		}
		
		var keepAnimation=false;
		if ($(this).attr('data-keep-animation')=="true") {
			keepAnimation=true;
		}		
		
		var targetBlank=false;
		if ($(this).attr('data-target-blank')=="true") {
			targetBlank=true;
		}	

		// we pre-hide a template position if given to improve user experience 
		// by giving a direct response on a click

		if ($(this).hasAttr('data-hide-template-position')) {
			var templatePosition=$(this).attr('data-hide-template-position');
			if (templatePosition=='tone-up-talk') {
				messaging.closeModal();
			} else {
				//console.log('data-hide-template-position attribute given, pre-hiding: ' + templatePosition);
				hideTemplatePosition(templatePosition);	
				templateOptions.hiddenTemplatePositions=[templatePosition];
				otuApp.appState.mapZIndex=$('.background-map-wrapper').css('z-index');
     		 	otuApp.appState.hiddenTemplatePositions=templateOptions.hiddenTemplatePositions;		
			}
		} else {
			otuApp.appState.mapZIndex			
			otuApp.appState.hiddenTemplatePositions=null;			
		}
		

		// add the ajax wrapper
		href=addParameterToURL(href, 'tmpl','ajax');
		
		// add the current step
		if (href.indexOf('currentStep=') === -1 && (typeof ((otuApp.appUser || {}).json || {}).currentStep !='undefined')) {
			href=addParameterToURL(href, 'currentStep',otuApp.appUser.json.currentStep);
		}
		
		// add the user ID
		if (href.indexOf('userIdCheck=') === -1 && (typeof ((otuApp.appUser || {}).id!='undefined'))) {
			if (otuApp.appUser.id!==0)
				href=addParameterToURL(href, 'userIdCheck', otuApp.appUser.id);
		}		

		const state = getStore().getState();

		/*
		if ( license.isTeacher() ) {
			href=addParameterToURL(href, 'classroomId',state.classrooms.classroom.id );
		}
		*/

		//if (otuApp.appState.missionId && !otuApp.appUser.guest)
		//href=addParameterToURL(href, 'missionId', otuApp.appState.missionId );

		var headers=otuApp.getHeaders();	
		
		var timeout=$.ajaxSetup().timeout;
		if ($(this).hasAttr('data-timeout')) {
			timeout=$(this).attr('data-timeout');
		}
					
		$.ajax( { 
			url:href,
			type:'GET',
			headers:headers,
			timeout:timeout,
			success:
				function( resultData ) {
					if (targetBlank) {
						var result=JSON.parse(resultData);
						//console.log(result.data.url);
						//console.log(resultData);

						window.open(result.data.url,'_blank');
						return true;
					}
					if (!keepAnimation) otuApp.stopAnimations();
					refreshTemplatePosition(resultData,templateOptions);
			}
		});	
	});	
	// Register the form POSTS
	$('form[data-ajax="true"]').off('submit');
	$('form[data-ajax="true"]').submit(function (e) {
		e.stopPropagation();	
		e.preventDefault();
		var templateOptions={};

		// we pre-hide a template position if given to improve user experience.
		// by giving a direct response on a click
		if ($(this).hasAttr('data-hide-template-position')) {
			//console.log('data-hide-template-position attribute given, pre-hiding: ' + templatePosition);
			var templatePosition=$(this).attr('data-hide-template-position');
			hideTemplatePosition(templatePosition);	
			templateOptions.hiddenTemplatePositions=[templatePosition];
			otuApp.appState.mapZIndex=$('.background-map-wrapper').css('z-index');
 		 	otuApp.appState.hiddenTemplatePositions=templateOptions.hiddenTemplatePositions;		
		} else {
			otuApp.appState.mapZIndex			
			otuApp.appState.hiddenTemplatePositions=null;			
		}
		
		var keepAnimation=false;
		if ($(this).attr('data-keep-animation')=="true") {
			keepAnimation=true;
		}	
		var target=	this.getAttribute('action');

		var headers=otuApp.getHeaders();	
		
		// add the current step
		if (target.indexOf('currentStep=') === -1 && (typeof ((otuApp.appUser || {}).json || {}).currentStep !='undefined')) {
			target=addParameterToURL(target, 'currentStep',otuApp.appUser.json.currentStep);
		}
		
		// add the user ID
		if (target.indexOf('userIdCheck=') === -1 && (typeof ((otuApp.appUser || {}).id!='undefined'))) {
			if (otuApp.appUser.id!==0)
				target=addParameterToURL(target, 'userIdCheck',otuApp.appUser.id);
		}	

		/*
		if ( license.isTeacher() ) {
			const state = getStore().getState();
			target=addParameterToURL(target, 'classroomId',state.classrooms.classroom.id );
		}
		*/

		//if (otuApp.appState.missionId && !otuApp.appUser.guest)
		//target=addParameterToURL(target, 'missionId', otuApp.appState.missionId );
		
		var postData=$(this).serialize();
		$.ajax({
			url: target,
			type:'POST',
			data:postData, 
			headers:headers,
			success:
				function( resultData ) {
						
					if (!keepAnimation) otuApp.stopAnimations();
					refreshTemplatePosition(resultData, templateOptions);

			}
		});
	});	

	//console.log('Ajax handlers done');

	return true;
}


otuApp.triggerAjaxGet = function (href,Options) {
	var options = {
			attr: {},
			debug:false,
			data:{},
			restoreTask:false
		};
	
	$.extend(options,Options );
	
	console.log('Ajax Handler - User Trigger Link');


	if ( otuApp.appState.fundraiserDomain && (href.startsWith('http') && !href.startsWith(otuApp.appState.rootUrl)) && !options.restoreTask) {
		// have an external link 
		console.log('Ajax Handler - Fundraiser reverse link', href,otuApp.appState.rootUrl);
		window.location.assign(href);
		return true;
	}

	// append the full url if it is missing
	if (!href.startsWith('http') && !href.startsWith(otuApp.appState.rootUrl) && !options.restoreTask) {
		console.log('Ajax Handler - Adding root url to link');
		href = otuApp.appState.rootUrl + href;
	}

	// a hack to stop the NSGG from running multiple times
	if (otuApp.appState.catchNsggRunning===true && href.indexOf('step=291')>0) {
		console.log('Nsgg - Already running not triggering a new one');
		return false;
	}
	
	var templateOptions={};
	
	var keepAnimation=false;
	if (options.attr['data-keep-animation']==="true" || options.attr['data-keep-animation']===true) {
		keepAnimation=true;
	}

	// we pre-hide a template position if given to improve user experience 
	// by giving a direct response on a click
	if (typeof (options.attr['data-hide-template-position']) != 'undefined') {
		var templatePosition=options.attr['data-hide-template-position'];
		//console.log('data-hide-template-position attribute given, pre-hiding: ' + templatePosition);
		hideTemplatePosition(templatePosition);	
		templateOptions.hiddenTemplatePositions=[templatePosition];
		otuApp.appState.mapZIndex=$('.background-map-wrapper').css('z-index');
		otuApp.appState.hiddenTemplatePositions=templateOptions.hiddenTemplatePositions;		
	} else {
		//otuApp.appState.mapZIndex			
		otuApp.appState.hiddenTemplatePositions=null;			
	}
		
	if (!(options.attr['data-disable-ajax-wrapper']==="true" || options.attr['data-disable-ajax-wrapper']===true)) {
		// add the ajax wrapper
		href=addParameterToURL(href, 'tmpl','ajax');
	} else {
		console.log('Ajax - wrapper disabled');
	}	
	
	// add the current step
	if (href.indexOf('currentStep=') === -1 && (typeof ((otuApp.appUser || {}).json || {}).currentStep !='undefined')) {
		href=addParameterToURL(href, 'currentStep',otuApp.appUser.json.currentStep);
	}
	
	// add the user ID
	if (href.indexOf('userIdCheck=') === -1 && (typeof ((otuApp.appUser || {}).id!='undefined'))) {
		if (otuApp.appUser.id!==0)
			href=addParameterToURL(href, 'userIdCheck', otuApp.appUser.id);
	}	

	/*
	if ( license.isTeacher() ) {
		const state = getStore().getState();
		href=addParameterToURL(href, 'classroomId', state.classrooms.classroom.id );
	}
	*/

	//if (otuApp.appState.missionId && !otuApp.appUser.guest)
	//href=addParameterToURL(href, 'missionId', otuApp.appState.missionId );
	
	var headers=otuApp.getHeaders();	

	$.ajax( {
		url:href, 
		type:'GET',
		headers:headers,
		myOptions:options,
		data:options.data,
		success: function( resultData ) {
			if (options.debug===true) {
				var win=window.open('about:blank');
			    win.document.open();
			    win.document.write(resultData);
			    win.document.close();
			}	
			if (!keepAnimation) {
				otuApp.stopAnimations();
			}
			refreshTemplatePosition(resultData,templateOptions);
			if (typeof options.callback !=='undefined') {
				options.callback();

//				otuApp.fxQ.queue(function(next){
//					options.callback();
//					next();
//				})
			}
		}	
	});	
	
}

otuApp.triggerAjaxPost = function(target,data,Options) {
	var options = {
			attr: {},
			debug:false,
			responseType:'template'
		};
	
	$.extend(options,Options );

	console.log('Ajax Handler - User Trigger Link');

	target=addParameterToURL(target, 'tmpl','ajax');

	var headers=otuApp.getHeaders();	
	
	var templateOptions={};
	
	// we pre-hide a template position if given to improve user experience 
	// by giving a direct response on a click
	if (typeof (options.attr['data-hide-template-position']) != 'undefined') {
		var templatePosition=options.attr['data-hide-template-position'];
		//console.log('data-hide-template-position attribute given, pre-hiding: ' + templatePosition);
		hideTemplatePosition(templatePosition);	
		templateOptions.hiddenTemplatePositions=[templatePosition];
		otuApp.appState.mapZIndex=$('.background-map-wrapper').css('z-index');
		otuApp.appState.hiddenTemplatePositions=templateOptions.hiddenTemplatePositions;		
	} else {
		otuApp.appState.mapZIndex			
		otuApp.appState.hiddenTemplatePositions=null;			
	}
			
	var keepAnimation=false;
	if (options.attr['data-keep-animation']==="true") {
		keepAnimation=true;
	}	
	
	// add the current step
	if (target.indexOf('currentStep=') === -1 && (typeof ((otuApp.appUser || {}).json || {}).currentStep !='undefined')) {
		target=addParameterToURL(target, 'currentStep', otuApp.appUser.json.currentStep);
	}
	
	// add the user ID
	if (target.indexOf('userIdCheck=') === -1 && (typeof ((otuApp.appUser || {}).id!='undefined'))) {
		if (otuApp.appUser.id!==0)
			target=addParameterToURL(target, 'userIdCheck', otuApp.appUser.id);
	}	

	/*
	if ( license.isTeacher() ) {
		const state = getStore().getState();
		target=addParameterToURL(target, 'classroomId', state.classrooms.classroom.id );
	}
	*/

	//if (otuApp.appState.missionId && !otuApp.appUser.guest)
	//target=addParameterToURL(target, 'missionId', otuApp.appState.missionId );
		
	var ajaxOptions={
			url:target,
			type:'POST',
			data:data,	
			headers:headers,
			myOptions:options,
			success:
				function( resultData, textStatusCode, jqXHR ) {
					if (options.debug===true) {
						var win=window.open('about:blank');
					    win.document.open();
					    win.document.write(resultData);
					    win.document.close();
					}
					//if (!keepAnimation) otuApp.stopAnimations();
					switch (options.responseType) {
						case 'template':
							refreshTemplatePosition(resultData, templateOptions);
							break;
						case 'json':

							if(resultData) {
								try{ 
								    resultData=JSON.parse(resultData);
									} catch(e) { 
										// although we requested json the result was not valid json, so we assume it is a template
										// toDo use the reponse headers or content type to set the resultData type
										// console.log('Ajax - JSON expected but template returned, callback ignored but error callback triggered');

										//if (typeof options.errorCallback !=='undefined') {
										//	options.errorCallback();
										//}

										templateOptions.jsonErrorCallback = options.errorCallback;
										templateOptions.jsonCallback = options.callback

										//var win=window.open('about:blank');
										/** **/
									    //win.document.open();
									    //win.document.write(resultData);
									    //win.document.close();
										refreshTemplatePosition(resultData, templateOptions);
										/** **/
										return true;
									}
							}							
					}
					
					if (typeof options.callback !=='undefined') {
						options.callback(resultData);
					}
				}
		};
	
	if (options.isFilePost) {
		ajaxOptions.cache=false;
		ajaxOptions.contentType= false;
		ajaxOptions.processData=false;	
	}

	if (options.showUploadProgress) {
		ajaxOptions.xhr = function()
		{
		  var xhr = new window.XMLHttpRequest();
		  //Upload progress
		  xhr.upload.addEventListener("progress", function(evt){
			if (evt.lengthComputable) {
			  var percentComplete = ( evt.loaded / evt.total) * 100;
			  //Do something with upload progress
			  console.log(percentComplete);
				$('#sys-upload-progress').html( Math.ceil(percentComplete) + '%');
			}
		  }, false);
		  //Download progress
		  xhr.addEventListener("progress", function(evt){
			if (evt.lengthComputable) {
			  var percentComplete = ( evt.loaded / evt.total) * 100;
			  //Do something with download progress
			  console.log(percentComplete);
				$('#sys-download-progress').html( Math.ceil(percentComplete) + '%');
			}
		  }, false);
		  return xhr;
		}
		$('.sys-upload-cancel').on('click',function () {
			console.log('Upload - Cancel')
			lastUploadAjaxCall.abort();
		})
		lastUploadAjaxCall = $.ajax(ajaxOptions);

	} else {
		$.ajax(ajaxOptions);
	}

}


/*
 * Functions to handle the browser back and forward buttons
 * Altough we detect them push and pop state technology is a minim requirement of the device
 * 
 * up for some improvement as it is a but buggy, and tricky
 * use 
 *   { "inHistory": false } in template params of appState to skip a page from history
 */

/* 
 * function that reloads to current historyState
 */

otuApp.jsBack = function (Options) {
	var options = {
			pop: true
		};
	$.extend(options,Options );
	
	if (options.pop) {
		console.log('History - Event Trigger -- App jsBack button');
		window.history.back();
	} else {
		console.log('History - Event Trigger -- Trigger reloading current history state');
		var state={state:window.history.state};
		console.log(state);
		popState(state);
	}
}

function queueNewBackForwardEvent(url) {
	historyQ.queue(function(next){
		//console.log(url);
			otuApp.triggerAjaxGet(url,{callback:function(){
				otuApp.fxQ.queue(function(nextFx) {
					next();
					nextFx();
				});
				
			}});				
	});	
}

function popState(e) {
	// we need to queue these to stop the app from crashing at multiple clicks
	
	if (otuApp.appState.isPdf) return true;

	  // e.state is equal to the data-attribute of the last image we clicked
	if (true || !otuApp.appUser.guest) {
		console.log('History - Event - browser/app Back/Forward button using Page Navigation');

		otuApp.pageNavigation.restoreTask();
		return true;
	}
	
	console.log('History - Event - browser/app Back/Forward button');

	// # this is sneaky we can disable the back button on our portal by returning false
	var step=null;
	var task=null;
	var url=null;
	var handled=false;
	
	// if we have the messaging modal open we close and preserve the state
	// @ToDo make it close any modal
	if (messaging.modalOpen) {
		messaging.closeModal();
		history.replaceState(e.state,'Operation Tone-Up Online Program');
		return true;
	}
	
	// we hide the menu if it is open
	if (typeof appMenu!='undefined') {
		if (!appMenu.hidden) {
			appMenu.hide();
			history.pushState(e.state,'Operation Tone-Up Online Program');
			return true;
		}	
	}
	
	if (e.state!=null) {
		var lastQuery=e.state.lastQuery;
		/*
		 * two types
		 *   1 a legacy task (use type 2 as this type 1 already deprecated)
		 *   2 an internal url
		 *   modalMessages close the modal box
		 */
		switch (e.state.type) {
			case 1:
				if (e.state!=null) step=e.state.id;
				task='goToStep&step=' + step;
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task='+ task + '&popHistory=1';
				console.log('History - Type 1 is deprecated !!!');

				break;
			case 2:
				url=e.state.lastPath + '?' + lastQuery + '&popHistory=1';
				//console.log('type2');

				break;	
			case 3:
				// we open the app menu and we open the island screen as the default page
				//appMenu.show();
				url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&view=ops&task=goToStep&step=0&inHistory=0';
				otuApp.triggerAjaxGet(url,{complete:function() {
						// we stop the seasounds
						otuApp.stopSeaSounds();
					}
				});
				//window.history.back();

				return true
			}
		
		if (url!=null || handled) {
			url=url.replace("wayBack=1","noWay=0");
			//console.log('History - Event (type ' + e.state.type + ') - back or forward to ' + url);
			if (step!=null) previousHistoryState.id=step;
 			previousHistoryState.lastQuery=lastQuery;
 			previousHistoryState.lastPath=e.state.lastPath;
 			previousHistoryState.backEvent=true;
 			
 			queueNewBackForwardEvent(url);

		} else {
			console.log('History - Error - Nowhere to go so we go back to the root of the request');
			url=otuApp.appState.rootUrl;
 			queueNewBackForwardEvent(url);
		
		}	
	} else {
		// for now we disable state=null handling on cordova and let the os decide (probably on next user tap the os will close the app)

		if (!otuApp.isCordovaApp()) {
			console.log('History - Top of Stack - Nowhere to go so we go back to the root of the request');
			//url=otuApp.appState.rootUrl;
 			//queueNewBackForwardEvent(url);
		// this is the preferred action but Safari cannot handle this as it is triggered on a page open
			window.history.back();				
		} else{
			console.log('History - Top of Stack - Nowhere to go on cordova ignored')
			// android same to have to same problem as safari here, the event is fired when the first screen is loaded too
			//window.history.back();				

		}

	}
	
	return true;
}

if (history.pushState) {
	window.addEventListener('popstate', popState);
}



/*
$( document ).ajaxStart(function() {
	$('.sys-message-modal .sys-message').hide();
	$('.sys-message-modal .loading-message').show();
	//$('.sys-message-modal').delay(200);
	$('.sys-message-modal').fadeIn(500);
	//$('.sys-message-modal').delay(15000);
	//$('.sys-message-modal').queue(function(next){
	//	$('.sys-message-modal .loading-message').fadeOut(next);
	//});
	//$('.sys-message-modal').queue(function(next){
	//	$('.sys-message-modal .loading-long-message').fadeIn(next);
	//})	
});*/

$.ajaxPrefilter( function ( options, originalOptions, jqXHR ) {
	console.log('Ajax Handler - Request ' +  options.url + ' type ' + options.type);
});

$( document ).ajaxSend(function(event,jqXHR,o) {
	if (typeof o.myOptions!='undefined') {
		if (typeof (o.myOptions.noSysInteraction!='undefined')) {
			if (o.myOptions.noSysInteraction) {
				console.log('Ajax - no ajax sys interaction - Send')
				return true;
			}
		}	
	}

	if (o.myOptions && o.myOptions.showUploadProgress) {
			otuApp.showLoading({id:'Ajax',type:'upload'});

	} else {
		otuApp.showLoading({id:'Ajax'});
	}
});

$( document ).ajaxSuccess(function(event,jqXHR,o) {
	if (typeof o.myOptions!='undefined') {
		if (typeof (o.myOptions.noSysInteraction!='undefined')) {
			if (o.myOptions.noSysInteraction) {
				console.log('Ajax - no ajax sys interaction - Success')
				return true;
			}
		}	
	}
	// only if we had a OK response we hide the sys screens... redundant?
	
	if (jqXHR.status==200) {
		otuApp.hideLoading({id:'Ajax'});
	}
	else {
		console.log('Ajax - request return status:' + jqXHR.status);
	}
});

$( document ).ajaxError(function(e,xhr,o,errorString) {
	
	if (o.myOptions && o.myOptions.showUploadProgress && errorString=='abort') {
		otuApp.hideLoading({id:'Ajax'});
		if (typeof o.myOptions.errorCallback ==='function') o.myOptions.errorCallback();
		return true;
	}
	console.log('Ajax - ajaxError');

	if (isDebugUser() && (!otuApp.isCordovaApp() || (!otuApp.isCordovaApp() && device.platform=='browser'))) {
		var wnd = window.open("about:blank", "_blank");
		wnd.document.write(xhr.responseText);
	}


	if (typeof o.myOptions!='undefined') {
		if (typeof (o.myOptions.noSysInteraction!='undefined')) {
			if (o.myOptions.noSysInteraction) {
				console.log('Ajax - no ajax sys interaction - Error')
				return true;
			}
		}	
	}
	
	if (typeof isPdf !='undefined') {
		console.log('Ajax - ignoring ajax errors on Pdf');
		return true;
	}
	
	$('.sys-message-modal').addClass('bg-black-transparent');
	
	if (otuApp.isCordovaApp()) {
		$('.sys-message-modal').stop(true,true);
		$('.sys-message-modal').hide();
		$('.sys-message-modal .sys-message').hide();
		frameWork.showNoServerError(o);
	} else {
		$('.sys-message-modal').stop(true,true);
		if (errorString!='timeout') {
			//$('.sys-message-modal .custom').html(errorString);;;
			$('.sys-message-modal').show();
			$('.sys-message-modal .sys-message').hide();
			$('.sys-message-modal .loading-error').fadeIn();
			$('.sys-message-modal .custom').fadeIn();
		} else {
			$('.sys-message-modal').show();
			$('.sys-message-modal .sys-message').hide();
			$('.sys-message-modal .timeout-error').fadeIn();			
			
		}
		$('.sys-message-modal .message-buttons').fadeIn();
		console.log(xhr);		
	}
	
	if (typeof otuApp.appState.templateParams!='undefined') {
		if (typeof otuApp.appState.templateParams.noJsErrorReporting!='undefined') {
			if (otuApp.appState.templateParams.noJsErrorReporting) return true;
		}
	}
	var agent='';
	if (typeof navigator!=='undefined') agent=navigator.userAgent;
	reportError({'agent':agent,'errorMsg':errorString, 'xhr':xhr,'options':o},otuApp.appState.lastPath + otuApp.appState.lastQuery);


});

otuApp.onTemplatePositionDestroy = function (event,_options) {
	// fired just before a template position gets replaced
	var options = {
		templatePosition:'columns-all'
	};
	$.extend(options,_options );

	console.log('Templates - Added onTemplatePositionDestroy event to ' + options.templatePosition);

	var _pos = $('[data-template-position="' + options.templatePosition + '"]');

	var events = $(_pos).data('onTemplatePositionDestroy');

	if (!Array.isArray(events)) events=[];

	events.push(event);

	$(_pos).data('onTemplatePositionDestroy',events);

}

otuApp.onTemplateBeforeHide = function (event,_options) {
	// fired just before a template position gets replaced
	var options = {
		templatePosition:'columns-all'
	};
	$.extend(options,_options );

	console.log('Templates - Added onTemplateBeforeHide event to ' + options.templatePosition);

	var _pos = $('[data-template-position="' + options.templatePosition + '"]');

	var events = $(_pos).data('onTemplateBeforeHide');

	if (!Array.isArray(events)) events=[];

	events.push(event);

	$(_pos).data('onTemplateBeforeHide',events);

}

otuApp.openLink = function(_options) {
	var options = {
		url:null,
		target:"_blank",
		inAppBrowserOptions:"location=yes"
	};
	$.extend(options,_options );

	console.log('otuApp - Opening External Link ' + options.url);
	console.log(options);;

	if (otuApp.isCordovaApp() && typeof cordova.inAppBrowser!=='undefined') {
		window.open(
			options.url,
			options.target,
			options.inAppBrowserOptions
		);
	} else {
		window.open(
			options.url,
			options.target
		)
	}	
}